import React, { lazy } from 'react';
const reviews = [{
  quote: 'A hauntingly documented account of our current cultural fracture. Not just a book — a mirror held up to an intolerant society.',
  name: 'James Sterling',
  role: 'Cultural Analyst & Political Commentator',
  avatar: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=192&h=192&fit=crop&crop=face'
}, {
  quote: 'Brutal, investigative, and deeply necessary. Every American concerned about the future of free speech needs to read the Epilogue.',
  name: 'Rebecca Thornton',
  role: 'Independent Journalist, Early Access Reviewer',
  avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=192&h=192&fit=crop&crop=face'
}, {
  quote: 'Finally — a work that captures the specific censorship mechanisms of 2025. Documentary storytelling at its most visceral level.',
  name: 'David Morales',
  role: 'Independent Legal Scholar & Constitutional Analyst',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=192&h=192&fit=crop&crop=face'
}];
export function ReviewsSection() {
  return <section className="w-full bg-editorial-bgAlt py-section-mobile md:py-section-desktop px-6 md:px-8 border-t border-editorial-divider bg-gradient-to-b from-editorial-bgAlt to-editorial-bg" data-id="element-133">
      <div className="max-w-3xl mx-auto" data-id="element-134">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-editorial-text text-center mb-12" data-id="element-135">
          What Readers Are Saying
        </h2>

        <div className="space-y-8 md:space-y-10 mb-12" data-id="element-136">
          {reviews.map((review, idx) => <div key={idx} className="bg-editorial-card p-8 md:p-10 rounded-xl flex flex-col items-start shadow-xl border border-editorial-divider/50" data-id="element-137">
              <span className="text-editorial-accent text-4xl font-serif leading-none mb-4" data-id="element-138">
                "
              </span>
              <p className="text-lg md:text-xl font-sans text-editorial-text leading-relaxed mb-8" data-id="element-139">
                {review.quote}
              </p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-140">
                <img src={review.avatar} alt={review.name} className="w-16 h-16 rounded-full object-cover" loading="lazy" data-id="element-141" />
                <div className="text-left" data-id="element-142">
                  <p className="text-base font-sans font-bold text-editorial-text" data-id="element-143">
                    {review.name}
                  </p>
                  <p className="text-sm font-sans text-editorial-textMuted" data-id="element-144">
                    {review.role}
                  </p>
                  <p className="text-xs font-sans text-editorial-textMuted mt-1" data-id="element-145">
                    ✅ Verified Early Access Reader
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <p className="text-xs font-sans text-editorial-textMuted text-center italic" data-id="element-146">
          Reader reviews reflect individual opinions.
        </p>
      </div>
    </section>;
}